import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row flex-wrap gap-5 items-stretch" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = {
  key: 0,
  class: "text-xs absolute rounded-sm shadow-sm top-0 right-1 px-1 py-0.5 transform -translate-y-3/4 bg-blue-600 text-white font-mono font-bold ring-2 ring-white",
  title: "Auto-detected type"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "sr-only" }, "Auto-detected type", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "sr-only" }, "Delete argument row", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Labeled = _resolveComponent("Labeled")!
  const _component_SmallTextInput = _resolveComponent("SmallTextInput")!
  const _component_SmallSelectInput = _resolveComponent("SmallSelectInput")!
  const _component_XCircleIcon = _resolveComponent("XCircleIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Labeled, { label: "Use" }, {
      default: _withCtx(() => [
        _createElementVNode("input", {
          class: "w-4 h-4 flex-grow self-center",
          type: "checkbox",
          checked: _ctx.active,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:active', $event.target.checked)))
        }, null, 40, _hoisted_2)
      ]),
      _: 1
    }),
    _createVNode(_component_Labeled, { label: "Field Name" }, {
      default: _withCtx(() => [
        _createVNode(_component_SmallTextInput, {
          theme: "light",
          class: "w-48",
          modelValue: _ctx.field,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:field', $event))),
          disabled: _ctx.locked
        }, null, 8, ["modelValue", "disabled"])
      ]),
      _: 1
    }),
    _createVNode(_component_Labeled, { label: "Data Type" }, {
      default: _withCtx(() => [
        _createVNode(_component_SmallSelectInput, {
          theme: "light",
          class: "w-32",
          modelValue: _ctx.type,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:type', $event))),
          options: _ctx.typeStrings
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }),
    _createVNode(_component_Labeled, { label: "Value" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_SmallTextInput, {
            theme: "light",
            class: "w-48",
            modelValue: _ctx.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:value', $event)))
          }, null, 8, ["modelValue"]),
          (_ctx.type === 'auto')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.guess.type), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.locked)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "text-xs absolute rounded-full cursor-pointer p-px top-1/2 left-full -translate-x-1/2 -translate-y-1/2 font-mono font-bold bg-white text-red-700 hover:text-red-600 focus:text-red-600",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('remove'))),
                title: "Delete argument row"
              }, [
                _hoisted_6,
                _createVNode(_component_XCircleIcon, { class: "w-6 h-6" })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}